import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Header from "./Header";
import Footer from "./Footer";

export default function MarkdownPage({ title, file }) {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch(file)
      .then((res) => res.text())
      .then(setContent)
      .catch(() => setContent("# Unable to load document."));
  }, [file]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />

      <main className="py-16">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-8 md:p-12 lg:p-16">

            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mb-10">
              {title}
            </h1>

            {content ? (
              <article
                className="
                  prose
                  prose-lg
                  prose-slate
                  max-w-none

                  leading-8

                  prose-p:my-6
                  prose-p:leading-8

                  prose-headings:scroll-mt-24
                  prose-headings:font-bold
                  prose-headings:text-slate-900
                  prose-headings:mt-12
                  prose-headings:mb-5

                  prose-h1:text-4xl
                  prose-h2:text-3xl
                  prose-h3:text-2xl

                  prose-ul:my-6
                  prose-ol:my-6

                  prose-li:my-2

                  prose-strong:text-slate-900

                  prose-a:text-[#65a30d]
                  prose-a:no-underline
                  hover:prose-a:underline

                  prose-blockquote:border-l-[#84cc15]
                "
              >
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {content}
                </ReactMarkdown>
              </article>
            ) : (
              <div className="text-slate-500 text-lg">
                Loading document...
              </div>
            )}

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
